import { Directive } from '@angular/core';
import { Output, EventEmitter, ElementRef, HostListener } from '@angular/core'
@Directive({
  selector: '[appClickOutside]'
})
export class ClickOutsideDirective {

  @Output() clickedOutsideOfThis = new EventEmitter<MouseEvent>();

  constructor(private eRef: ElementRef) {
  }

  @HostListener('document:click', ['$event']) onDocumentClick(event) {
    this.clickedOutsideOfThis.emit();
  }

  @HostListener('click', ['$event']) onClick(e: MouseEvent) {
    e.stopPropagation();
  }

}
